import { Route, Routes } from 'react-router-dom'

import Layout from './components/Layout'
import RequireAuth from './components/RequireAuth'
import Home from './pages/Home'
import AdminUsers from './pages/AdminUsers'
import ProcessBuilder from './pages/ProcessBuilder'
import BxSmart from './pages/BxSmart'
import BxLists from './pages/BxLists'
import ContractCard from './pages/ContractCard'
import DealLinks from './pages/DealLinks'
import Certs from './pages/Certs'
import Client360 from './pages/Client360'
import Analytics from './pages/Analytics'
import Companies from './pages/Companies'
import Dashboard from './pages/Dashboard'
import CompanyCard from './pages/CompanyCard'
import ContactCard from './pages/ContactCard'
import Contacts from './pages/Contacts'
import DealCard from './pages/DealCard'
import DealChain from './pages/DealChain'
import Deals from './pages/Deals'
import Bank from './pages/Bank'
import Money from './pages/Money'
import AutoVerifications from './pages/AutoVerifications'
import BpTasks from './pages/BpTasks'
import EquipDue from './pages/EquipDue'
import CrossReports from './pages/CrossReports'
import DataQuality from './pages/DataQuality'
import Mismatches from './pages/Mismatches'
import VesselMerge from './pages/VesselMerge'
import Nelikvid from './pages/Nelikvid'
import EngineerLedger from './pages/EngineerLedger'
import Initiatives from './pages/Initiatives'
import CoordProjects from './pages/CoordProjects'
import Gratitude from './pages/Gratitude'
import EngineerSchedule from './pages/EngineerSchedule'
import FleetOwners from './pages/FleetOwners'
import AvrParsed from './pages/AvrParsed'
import Cards from './pages/Cards'
import Docs from './pages/Docs'
import PrintForms from './pages/PrintForms'
import BpeTasks from './pages/BpeTasks'
import Leads from './pages/Leads'
import Tasks from './pages/Tasks'
import Estimate from './pages/Estimate'
import RadioRef from './pages/RadioRef'
import Calendar from './pages/Calendar'
import NotifyQueue from './pages/NotifyQueue'
import Absence from './pages/Absence'
import MyProfile from './pages/MyProfile'
import Carsharing from './pages/Carsharing'
import Overtime from './pages/Overtime'
import NewDeal from './pages/NewDeal'
import EquipActs from './pages/EquipActs'
import Health from './pages/Health'
import JobReports from './pages/JobReports'
import Login from './pages/Login'
import Purchasing from './pages/Purchasing'
import Prices from './pages/Prices'
import QuoteBuilder from './pages/QuoteBuilder'
import Receivables from './pages/Receivables'
import Reports from './pages/Reports'
import RsProducts from './pages/RsProducts'
import RsSuppliers from './pages/RsSuppliers'
import RsVessels from './pages/RsVessels'
import SalesRating from './pages/SalesRating'
import Verifications from './pages/Verifications'
import SmartProcess from './pages/SmartProcess'
import Shipping from './pages/Shipping'
import Stock from './pages/Stock'
import VesselCard from './pages/VesselCard'
import Vessels from './pages/Vessels'

// Новый раздел CRM = один Route здесь + страница в pages/. Так масштабируются «адаптации».
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        {/* Стартовая сводка набора. Учётка без набора получает прежний редирект
            на /deals — его делает сам Home, поэтому Navigate здесь больше не нужен. */}
        <Route path="/" element={<Home />} />
        <Route path="/deals" element={<Deals />} />
        {/* Раньше /deals/:id: статический сегмент у React Router и так выигрывает у
            параметра, но порядок в файле читается однозначнее. Единственный раздел,
            который ПИШЕТ в Bitrix, — там предупреждение и подтверждение обязательны. */}
        {/* Сквозной путь сделки: где работа встала. Отдельно от карточки, потому что
            это взгляд поперёк сущностей, а не ещё одна вкладка сделки. */}
        <Route path="/chain" element={<DealChain />} />
        <Route path="/chain/:id" element={<DealChain />} />
        <Route path="/deals/new" element={<NewDeal />} />
        <Route path="/deals/:id" element={<DealCard />} />
        <Route path="/receivables" element={<Receivables />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/companies/:id" element={<CompanyCard />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/contacts/:id" element={<ContactCard />} />
        <Route path="/vessels" element={<Vessels />} />
        <Route path="/vessels/:id" element={<VesselCard />} />
        {/* Сотрудник в query (?user=58) — теперь только ПЕРЕОПРЕДЕЛЕНИЕ для head/admin:
            умолчание даёт привязка учётки из /api/me (api/self.ts), у роли user выбора нет. */}
        <Route path="/dashboard" element={<Dashboard />} />
        {/* Отчёты руководителя над зеркалом exec-панели. Кассы и ФОТ здесь нет: пока
            владелец не решил, кто видит зарплаты, ядро эти таблицы не читает вовсе. */}
        <Route path="/reports" element={<Reports />} />
        {/* Касса и ФОТ. Пункт меню появляется только у владельца, но маршрут доступен
            всем вошедшим — защита не здесь, а на сервере: BFF и ядро проверяют учётку
            каждый по отдельности. Экран у не-владельца получит отказ и объяснит его. */}
        <Route path="/bank" element={<Bank />} />
        <Route path="/money" element={<Money />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/overtime" element={<Overtime />} />
        {/* Ведомость инженера портала 73. ТОЛЬКО ЧТЕНИЕ и только учётке владельца:
            это заработок людей поимённо, тот же разряд данных, что касса и овертаймы. */}
        <Route path="/engineer-ledger" element={<EngineerLedger />} />
        {/* Инициативы инженеров: вознаграждение поимённо. ТОЛЬКО ЧТЕНИЕ и только
            учётке владельца — тот же разряд данных, что ведомость и касса. */}
        <Route path="/initiatives" element={<Initiatives />} />
        {/* Проекты координатора с брифинга. Карточка заводится ТАМ сама при первом
            открытии экрана проекта по сделке, поэтому экран по умолчанию показывает
            только заполненные: иначе чужие клики читались бы как работа. */}
        <Route path="/coord-projects" element={<CoordProjects />} />
        {/* Благодарности: письма заказчиков и значки. Само письмо и его фото в
            зеркало не переносятся — виден только след начисления. */}
        <Route path="/gratitude" element={<Gratitude />} />
        {/* Календарь инженеров. Отпуска, больничные, командировки и отгулы учтены с
            29.07.2026 — из «Графика отсутствий» Bitrix, того же источника, что и раздел
            «Отсутствия». До этого их не было вовсе, и цена была видна числом: в окне
            −3…+30 дней 59 полевых сотрудников из 161 числились свободными, будучи в
            отпуске или командировке, — календарь буквально предлагал ставить их на судно.
            Причина отсутствия не показывается: рядом с «больничным» это сведения о
            здоровье. */}
        <Route path="/engineer-schedule" element={<EngineerSchedule />} />
        {/* Наш флот и владельцы. Позиций судов и контактов чужих судовладельцев
            здесь нет: этих слоёв в зеркале не существует. */}
        <Route path="/fleet" element={<FleetOwners />} />
        {/* Разборы актов АВР. Часов и исполнителей здесь нет — ядро их не выбирает,
            решение о видимости за владельцем. */}
        <Route path="/avr-parsed" element={<AvrParsed />} />
        {/* Конструктор карточек. Кода раздела в правах пока НЕТ намеренно: это чтение
            поддельных данных, живых записей за ним не стоит. Появятся — заводим
            раздел 'cards' в rights.py ДО того, как подключим транспорт. */}
        <Route path="/cards" element={<Cards />} />
        <Route path="/deal-docs" element={<Docs />} />
        {/* Печатные формы из своей базы — то, чем компания будет печатать после
            отключения Bitrix. Отказ печатать приходит успехом с причинами: данные
            не готовы — это не поломка, и экран не должен звать чинить не то. */}
        <Route path="/print-forms" element={<PrintForms />} />
        {/* Задания СВОЕГО движка процессов. Пока движок не запускали, строк ноль —
            экран говорит именно это, а не показывает пустую таблицу. Ответить
            нельзя: ручки записи в ядре нет вовсе, и кнопка честно выключена. */}
        <Route path="/bpe-tasks" element={<BpeTasks />} />
        <Route path="/bpe-defs" element={<ProcessBuilder />} />
        <Route path="/bx-smart" element={<BxSmart />} />
        <Route path="/bx-lists" element={<BxLists />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/estimate" element={<Estimate />} />
        <Route path="/radio-ref" element={<RadioRef />} />
        {/* Календарь Bitrix из зеркала. Частные события — время и занятость без
            текста; отпуска — в «Отсутствиях», связи между слоями нет и не рисуем. */}
        <Route path="/calendar" element={<Calendar />} />
        {/* Очередь уведомлений движка. Только чтение; тел уведомлений здесь нет. */}
        <Route path="/notify-queue" element={<NotifyQueue />} />
        {/* Отсутствия. В графике Bitrix большинство записей — блокировка календаря
            под работу по заявке, а не отпуск; экран по умолчанию показывает четыре
            настоящих вида и говорит об этом. Денег командировки здесь нет. */}
        <Route path="/absence" element={<Absence />} />
        {/* Личный кабинет: СВОИ данные и только свои. Раздел за флагом владельца
            (WEB_PROFILE_ENABLED): данные лежат в разделах, закрытых на одну учётку. */}
        <Route path="/my-profile" element={<MyProfile />} />
        {/* Каршеринг: служебный транспорт — учёт вещи, а не чей-то доход.
            Номера и адреса личных машин закрыты маской в ядре, а не на экране. */}
        <Route path="/carsharing" element={<Carsharing />} />
        {/* Клиент в query (?company=77), а не в пути: ссылку на срез клиента пересылают. */}
        <Route path="/clients" element={<Client360 />} />
        {/* Инженерный блок портала 73. Список и карточка — один компонент: у верификации
            карточка это тот же чек-лист, что и строка списка, только развёрнутый. */}
        <Route path="/verifications" element={<Verifications />} />
        <Route path="/verifications/:id" element={<Verifications />} />
        <Route path="/job-reports" element={<JobReports />} />
        <Route path="/job-reports/:id" element={<JobReports />} />
        <Route path="/equip-acts" element={<EquipActs />} />
        <Route path="/equip-acts/:id" element={<EquipActs />} />
        <Route path="/auto-verifications" element={<AutoVerifications />} />
        <Route path="/equip-due" element={<EquipDue />} />
        {/* Закупки и отгрузка. Заявка ЗКП живёт только в хранилище портала 55 — сюда
            попадает то, что дошло до Bitrix (смарт-процесс 1160) и до 1С (заказы
            поставщику, реализации). Экран об этом говорит сам. */}
        {/* Реестр РМРС. Карточка сервисника — в query, а не сегментом: в названиях
            реестра кавычки и точки, в пути это простыня %-кодов. */}
        {/* Ключ файла — в query: это путь с косыми чертами, кириллицей и пробелами,
            сегментом пути он ломается. */}
        <Route path="/certs" element={<Certs />} />
        <Route path="/rs/vessels" element={<RsVessels />} />
        <Route path="/rs/vessels/:imo" element={<RsVessels />} />
        <Route path="/rs/products" element={<RsProducts />} />
        <Route path="/rs/products/:id" element={<RsProducts />} />
        <Route path="/rs/suppliers" element={<RsSuppliers />} />
        <Route path="/prices" element={<Prices />} />
        <Route path="/quote" element={<QuoteBuilder />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/sales-rating" element={<SalesRating />} />
        <Route path="/purchasing" element={<Purchasing />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/nelikvid" element={<Nelikvid />} />
        {/* Задания бизнес-процессов Bitrix. ТОЛЬКО ЧТЕНИЕ: закрыть задание можно лишь
            в Bitrix — он выполняет только СВОЁ задание, а CRM ходит служебным вебхуком. */}
        <Route path="/bp-tasks" element={<BpTasks />} />
        <Route path="/xreports" element={<CrossReports />} />
        <Route path="/deal-links" element={<DealLinks />} />
        {/* Свод по всему, чему в зеркале нельзя верить. ТОЛЬКО ЧТЕНИЕ: почти всё
            найденное чинится в источнике, а не у нас. */}
        <Route path="/data-quality" element={<DataQuality />} />
        <Route path="/mismatches" element={<Mismatches />} />
        {/* Сведение карточек-дублей судов. ТОЛЬКО ЧТЕНИЕ: свести можно лишь в Bitrix,
            и порядок действий там важнее скорости. */}
        <Route path="/vessel-merge" element={<VesselMerge />} />
        {/* Один маршрут на пять разделов: счета, платёжный календарь, договоры, АВР,
            отчёты. Состав колонок строится из справочника полей, поэтому шестой тип
            добавляется строкой в lib/smart.ts, а не новым экраном. */}
        <Route path="/smart/contracts/:id" element={<ContractCard />} />
        <Route path="/smart/:type" element={<SmartProcess />} />
        <Route path="/health" element={<Health />} />
        <Route path="*" element={<div className="card">Страница не найдена</div>} />
      </Route>
    </Routes>
  )
}
